import React from 'react';

import { Container } from './styles';

function ErrorExipred() {
  return (
    <Container>
      <div>
        <img src="/static/time_expired.svg" alt="" />
        <h2>O tempo de inscrição para a vaga foi esgotado!</h2>
      </div>
    </Container>
  );
}

export default ErrorExipred;
